"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _components = require("@engaging-tech/components");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Copyright = _interopRequireDefault(require("./Copyright"));
var _FooterLinks = _interopRequireDefault(require("./FooterLinks"));
var _Logo = _interopRequireDefault(require("./Logo"));
var _SocialMediaIcons = _interopRequireDefault(require("./SocialMediaIcons"));
var Wrapper = (0, _styledComponents["default"])(_components.Box).withConfig({
  displayName: "Footer__Wrapper",
  componentId: "sc-ra9nlj-0"
})(["border-top:1px solid ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.dark[4];
});

/**
 * A branded footer for Engaging products.
 *
 * See the README in @engaging-tech/navigation/footer to learn more about
 * how to use the footer.
 *
 * @param {array} sections An array of sections to render as columns
 * within the footer.
 * @param {array} socialMedia Social media network links.
 * @param {Object} logo Logo information
 * @param {React.Component} Logo Logo component
 * @param {React.Component} badges iOS & Android app badges.
 */
var Footer = function Footer(_ref2) {
  var sections = _ref2.sections,
    socialMedia = _ref2.socialMedia,
    Logo = _ref2.Logo,
    logo = _ref2.logo,
    Badges = _ref2.badges,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? "WorkL" : _ref2$name,
    boldText = _ref2.boldText;
  return /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    as: "footer",
    justifyContent: "center",
    width: "100%"
  }, /*#__PURE__*/_react["default"].createElement(Wrapper, {
    maxWidth: 1024,
    px: [3, 3, 4],
    pt: 4,
    pb: [6, 4]
  }, /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    width: "100%",
    flexDirection: ["column", "row"],
    justifyContent: ["flex-start", "space-between"],
    mb: [5, 3]
  }, /*#__PURE__*/_react["default"].createElement(_FooterLinks["default"], {
    sections: sections,
    boldText: boldText
  }), Badges && /*#__PURE__*/_react["default"].createElement(Badges, null)), /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    width: "100%",
    mb: [5, 3],
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_SocialMediaIcons["default"], {
    networks: socialMedia
  })), /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: ["column", "row", "row"]
  }, Logo && /*#__PURE__*/_react["default"].createElement(Logo, null), logo && /*#__PURE__*/_react["default"].createElement(_Logo["default"], (0, _extends2["default"])({}, logo, {
    mb: [1, 0, 0]
  })), /*#__PURE__*/_react["default"].createElement(_Copyright["default"], {
    name: name
  }))));
};
var _default = exports["default"] = Footer;